module.exports = __webpack_public_path__ + "media/images/common/send_btn_l_ov-3c9b482c62db6c4a50323bf6bd3c96b7.png";